import { inject, Injectable } from '@angular/core';
import { NavigationCancel, Router } from '@angular/router';
import { filter } from 'rxjs';

const ROUTE_CHECK_STORAGE_KEY = 'ss-route-check-url';
const ACCOUNT_ROUTE_PREFIX = '/account';

@Injectable({ providedIn: 'root' })
export class RouteCheckService {

	router = inject(Router);

	url = window.localStorage.getItem(ROUTE_CHECK_STORAGE_KEY) ?? '';

	constructor() {
		this.router.events
			.pipe(filter((event): event is NavigationCancel => event instanceof NavigationCancel))
			.subscribe((event: NavigationCancel) => {
				if (event.url.startsWith(ACCOUNT_ROUTE_PREFIX)) return;
				this.url = event.url;
				window.localStorage.setItem(ROUTE_CHECK_STORAGE_KEY, this.url);
			});
	}

	navigateToExistingUrl() {
		const existingUrl = this.url || window.localStorage.getItem(ROUTE_CHECK_STORAGE_KEY) || '/';
		this.router.navigateByUrl(existingUrl);
		this.url = '';
		window.localStorage.removeItem(ROUTE_CHECK_STORAGE_KEY);
	}
}
